export const userDetailsSelector = (state) => state.authentication.userDetails;
export const userRolesSelector = (state) => state.authentication.userRoles;
export const userEntitiesSelector = (state) => state.authentication.userEntities;
export const contactTypeSelector = (state) => state.authentication.contactTypeList;
export const countriesListSelector = (state) => state.authentication.countries;
export const userMenuListSelector = (state) => state.authentication.userMenu;
